import React from "react";
import { api } from "../lib/api";
import { useApp } from "../context/AppContext";
import { Star, Shield, Award, ExternalLink } from "lucide-react";

// Affiliate casino partners — REPLACE affiliate_url with your real tracking links
const PARTNERS = [
  { id: "stake", name: "Stake.com", rating: 4.9, established: 2017, license: "Curaçao", bonus: "200% up to $2,000", features: ["Crypto", "Fast payouts", "VIP club"], color: "from-cyan-500 to-blue-600", tag: "Editor's Choice",
    affiliate_url: "https://stake.com/?c=havana" },
  { id: "bcgame", name: "BC.Game", rating: 4.7, established: 2017, license: "Curaçao", bonus: "Up to 5 BTC + 200 FS", features: ["Crypto", "Daily wheel", "8,000+ games"], color: "from-red-500 to-orange-500",
    affiliate_url: "https://bc.game/?i=havana" },
  { id: "rollbit", name: "Rollbit", rating: 4.6, established: 2020, license: "Curaçao", bonus: "1,000 RLB + Rakeback", features: ["NFT sports", "Trading", "Instant"], color: "from-purple-500 to-pink-500",
    affiliate_url: "https://rollbit.com/?ref=havana" },
  { id: "duelbits", name: "Duelbits", rating: 4.5, established: 2020, license: "Curaçao", bonus: "Rakeback + Rain", features: ["Provably fair", "PvP games", "Crypto"], color: "from-indigo-500 to-purple-600", tag: "Rising",
    affiliate_url: "https://duelbits.com/?ref=havana" },
  { id: "roobet", name: "Roobet", rating: 4.5, established: 2019, license: "Curaçao", bonus: "$1,000 + Weekly Raffle", features: ["Crash", "Mines", "Streamer favorite"], color: "from-yellow-500 to-orange-600",
    affiliate_url: "https://roobet.com/?ref=havana" },
  { id: "trustdice", name: "TrustDice", rating: 4.3, established: 2018, license: "Curaçao", bonus: "3 BTC Welcome", features: ["EOS chain", "Faucet", "Sports"], color: "from-emerald-500 to-teal-600",
    affiliate_url: "https://trustdice.win/?ref=havana" },
  { id: "cloudbet", name: "Cloudbet", rating: 4.6, established: 2013, license: "Montenegro", bonus: "5 BTC + 100 FS", features: ["Long-standing", "Sports", "Live casino"], color: "from-blue-500 to-cyan-600",
    affiliate_url: "https://cloudbet.com/?af=havana" },
  { id: "1xbit", name: "1xBit", rating: 4.4, established: 2016, license: "Curaçao", bonus: "7 BTC across 4 deposits", features: ["Sports betting", "Multi-currency", "40+ cryptos"], color: "from-slate-500 to-blue-600",
    affiliate_url: "https://1xbit.com/?tag=havana" },
  { id: "sportsbetio", name: "Sportsbet.io", rating: 4.5, established: 2016, license: "Curaçao", bonus: "Price boost + cashback", features: ["Sports focus", "Live streams", "PL sponsor"], color: "from-red-600 to-purple-600",
    affiliate_url: "https://sportsbet.io/?aff=havana" },
  { id: "primedice", name: "Primedice", rating: 4.4, established: 2013, license: "Curaçao", bonus: "Faucet + Rain events", features: ["Dice-focused", "Provably fair", "OG platform"], color: "from-amber-500 to-yellow-600",
    affiliate_url: "https://primedice.com/?ref=havana" },
  { id: "empire", name: "Empire.io", rating: 4.3, established: 2021, license: "Curaçao", bonus: "10 BTC + Rakeback", features: ["Live dealers", "5,000+ slots", "24/7 support"], color: "from-yellow-600 to-orange-600",
    affiliate_url: "https://empire.io/?ref=havana" },
  { id: "bitstarz", name: "BitStarz", rating: 4.7, established: 2014, license: "Curaçao", bonus: "5 BTC + 180 FS", features: ["Award-winning", "Fast payouts", "3,600+ games"], color: "from-fuchsia-500 to-pink-600", tag: "Best Payouts",
    affiliate_url: "https://bitstarz.com/?ref=havana" },
];

function Stars({ rating }) {
  const full = Math.floor(rating);
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} size={12} className={i < full ? "text-[#d4af37] fill-[#d4af37]" : "text-white/20"} />
      ))}
      <span className="text-xs text-white/60 ml-1">{rating.toFixed(1)}</span>
    </div>
  );
}

export default function Casinos() {
  const { lang } = useApp();
  const trackClick = async (partner) => {
    try { await api.post("/affiliates/click", { partner_id: partner.id, partner_name: partner.name }); } catch {}
    window.open(partner.affiliate_url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="max-w-[1500px] mx-auto px-6 py-12">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.4em] text-[#d4af37]">Reviews · 2026</div>
        <h1 className="font-serif text-4xl md:text-5xl mt-2">Top Rated Casinos</h1>
        <p className="text-white/50 mt-2 max-w-2xl">
          {lang === "hu"
            ? "Kézzel válogatott, licencelt online kaszinók globális ajánlatokkal. Kattints, és megnyíljon a partner oldalon."
            : "Hand-picked, licensed online casinos with global bonus offers. Click through to open the partner site."}
        </p>
      </div>

      <div className="lux-card p-4 mb-8 flex items-start gap-3 text-xs text-white/60 bg-yellow-950/20 border-yellow-500/20">
        <Shield className="text-yellow-500 shrink-0" size={18}/>
        <div>
          <strong className="text-yellow-400">18+ · Play Responsibly.</strong>{" "}
          {lang === "hu"
            ? "A linkek affiliate hivatkozásokat tartalmaznak — vásárláskor jutalékot kaphatunk, ez neked semmibe nem kerül. A kaszinók a saját joghatóságuk szerint működnek."
            : "Links contain affiliate tracking — we may earn a commission at no extra cost to you. Casinos operate under their own jurisdictions."}
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {PARTNERS.map(p => (
          <div key={p.id} data-testid={`casino-card-${p.id}`} className="lux-card overflow-hidden group">
            <div className={`relative h-32 bg-gradient-to-br ${p.color} flex flex-col items-center justify-center`}>
              {p.tag && (
                <div className="absolute top-3 right-3 bg-black/60 backdrop-blur border border-[#d4af37]/40 rounded-full px-3 py-1 text-[9px] uppercase tracking-widest text-[#d4af37] flex items-center gap-1">
                  <Award size={10}/>{p.tag}
                </div>
              )}
              <div className="font-serif text-3xl text-white drop-shadow-lg">{p.name}</div>
              <div className="text-white/70 text-[10px] mt-1 uppercase tracking-widest">Est. {p.established} · {p.license}</div>
            </div>
            <div className="p-4">
              <Stars rating={p.rating}/>
              <div className="mt-3 rounded bg-[#0a0a0a] border border-[#d4af37]/20 p-3">
                <div className="text-[9px] uppercase text-[#d4af37] tracking-widest">Welcome Bonus</div>
                <div className="font-bold mt-0.5">{p.bonus}</div>
              </div>
              <div className="flex flex-wrap gap-1 mt-3">
                {p.features.map(f => (
                  <span key={f} className="text-[10px] px-2 py-0.5 rounded bg-white/5 border border-white/10 text-white/70">{f}</span>
                ))}
              </div>
              <button data-testid={`casino-play-${p.id}`} onClick={()=>trackClick(p)}
                      className="w-full btn-gold px-4 py-2.5 rounded mt-4 text-sm uppercase tracking-widest flex items-center justify-center gap-1">
                Play Now <ExternalLink size={14}/>
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center text-white/40 text-xs mt-10">
        {lang === "hu"
          ? "Ez az oldal 3rd party kaszinókat mutat be és affiliate jutalékkal működik. Ha problémád van szerencsejáték függőséggel, hívd a segélyvonalat: +36 80 15 15 15."
          : "This page features 3rd-party casinos and earns via affiliate commissions. If gambling is a problem, call the National Helpline."}
      </div>
    </div>
  );
}
